import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "flowbite-react";
import { RiGraduationCapFill } from "react-icons/ri";
import { CiStar } from "react-icons/ci";
import { GrRun } from "react-icons/gr";
import "../elearningHub/ElearningHub.css";
import "../courseInternal/CourseInternalComponent.css";
import HeaderComponent from "../header/HeaderComponent";
import FooterComponent from "../footer/FooterComponent";
import TaskCard from "../taskCard/taskCard";
import FavoriteCard from "../favoriteCard/favoriteCard";
import { useCourseContent } from "../../context/CourseContentContext";

const CourseInternalComponent = ({ course }) => {
  const { nameCourse } = useParams()
  const hasLogged = useRef(false);
  const { dataCourse, getDataCourse, dataTasks, sendLog } = useCourseContent()
  const [activeTab, setActiveTab] = useState('task');

  useEffect(() => {
    getDataCourse(course.id);
  }, [course])

  useEffect(() => {
    if (!hasLogged.current && dataCourse?.title) {
      sendLog(dataCourse.title);
      hasLogged.current = true;
    }
  }, [dataCourse?.title]);

  return (
    <>
      <HeaderComponent />
      <div className="breadcrumb-section mb-3">
        <Breadcrumb aria-label="Default breadcrumb example container main-section p-0">
          <ol className="flex items-center container main-section p-0">
            <BreadcrumbItem
              className="flex items-center text-md font-bold text-white hover:text-white dark:text-white dark:hover:text-white"
              href="#"
            >
              <Link
                to="/e-learning-hub"
                className={`nav-link text-white ApisBold fs-5 text-decoration-none text-items-nav`}
                style={{ color: "inherit" }}
              >
                E-learning Hub
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem
              className="flex items-center text-md font-bold text-white hover:text-white dark:text-white dark:hover:text-white"
              href="#"
            >
              <Link
                to={`/cursos/${nameCourse}`}
                className={`nav-link text-white ApisBold fs-5 text-decoration-none text-items-nav`}
                style={{ color: "inherit" }}
              >
                {dataCourse?.title}
              </Link>
            </BreadcrumbItem>
          </ol>
        </Breadcrumb>
      </div>
      {/* card principal */}
      <div className="container flex flex-col">
        <div className="relative">
          <div className="col-12 col-md-11 col-lg-12 background-e-learning top-0 p-0 pt-3 px-3 mb-5">
            <div className="w-full m-0 p-0 flex flex-col lg:flex-row">
              <div className="w-full lg:w-1/2 mt-2 lg:mt-0 flex flex-col items-start justify-start">
                <h1 className="text-2xl font-bold text-purple-800">{dataCourse?.title}</h1>
                <p className="ApisRegular text-xs p-2 m-0 text-justify text-purple">
                  Complete las tareas asignadas para desbloquear su certificado. Cada actividad lo acerca un
                  paso más a alcanzar sus objetivos.
                </p>
              </div>

              <div className="w-full lg:w-1/2 mt-2 lg:mt-0 flex flex-col items-start sm:mx-5 lg:mx-5 xl:mx-5 justify-center">
                <div className="flex items-center">
                  <div>
                    <GrRun style={{ fontSize: '1.5rem', color: '#4D2484' }} />
                  </div>
                  <p className="ApisRegular text-xs p-2 m-0 text-justify text-purple">
                    <span className="ApisBold">¡Muy bien!</span> Lleva más del <span className="ApisBold">{Math.round(dataCourse?.progress_user_course)}%</span> del curso aprobado.
                  </p>
                </div>

                <div className="w-full flex items-center">
                  <div className="w-full bg-gray-200 mb-4 dark:bg-gray-700 ">
                    <div className=" h-4 dark:bg-blue-500 loader" style={{ width: `${dataCourse?.progress_user_course}%` }}></div>
                  </div>
                </div>

              </div>
            </div>

            <div className="w-full mt-2 lg:mt-0 flex flex-col items-start justify-start">

              <div className="w-full">
                <div className="mb-4">
                  <ul className="flex flex-wrap -mb-px text-sm font-medium text-center" role="tablist">

                    <li className="me-2" role="presentation">
                      <button
                        className={`inline-block rounded-lg py-[0.5rem] px-3 ${activeTab === 'task' ? 'btn-bg-custom-green text-white' : 'btn-bg-custom-gray text-custom-gray'}`}
                        onClick={() => {
                          setActiveTab('task')
                          sendLog(dataCourse?.title, null, null, null, 'view-tasks');
                        }}
                        type="button"
                        role="tab"
                        aria-controls="task"
                        aria-selected={activeTab === 'task' ? 'true' : 'false'}
                      >
                        <RiGraduationCapFill className="inline-block mr-2" />
                        Tareas
                      </button>
                    </li>

                    <li className="me-2" role="presentation">
                      <button
                        className={`inline-block rounded-lg py-[0.5rem] px-3 ${activeTab === 'dashboard' ? 'btn-bg-custom-green text-white' : 'btn-bg-custom-gray text-custom-gray'}`}
                        onClick={() => {
                          setActiveTab('dashboard')
                          sendLog(dataCourse?.title, null, null, null, 'view-favorites');
                        }}
                        type="button"
                        role="tab"
                        aria-controls="dashboard"
                        aria-selected={activeTab === 'dashboard' ? 'true' : 'false'}
                      >
                        <CiStar className="inline-block mr-2" />
                        Favoritos
                      </button>
                    </li>

                  </ul>
                </div>

                <div id="default-tab-content">
                  <div
                    className={`rounded-lg ${activeTab === 'task' ? 'block' : 'hidden'}`}
                    id="task"
                    role="tabpanel"
                    aria-labelledby="task-tab"
                  >
                    <div className="pt-1">
                      <div className="p-6 py-0">
                        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-8 mt-4 relative">

                          {dataTasks?.map((task, index) => (
                            <TaskCard
                              key={index}
                              task={task}
                              courseId={course.id}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`rounded - lg ${activeTab === 'dashboard' ? 'block' : 'hidden'}`}
                    id="dashboard"
                    role="tabpanel"
                    aria-labelledby="dashboard-tab"
                  >
                    <div className="pt-1">
                      <div className="p-6 py-0">
                        <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-8 mt-4 relative">
                          {dataTasks?.map((task, index) => (
                            <FavoriteCard
                              key={index}
                              task={task}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>

          </div>
        </div>
      </div >
      <FooterComponent />
    </>

  );

}


export default CourseInternalComponent;